import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map } from "rxjs/operators";
import { Estado } from "@/models/estado";

const estado = require("@/query/Estado.graphql");

export class EstadoAPI extends BaseAPI<Estado> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/passe-livre`;
  }

  public getAll(): AxiosObservable<Estado[]> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(estado),
        variables: {}
      })
      .pipe(
        map((data: any) => {
          const { estados } = data;

          return estados.map(
            (estado: any) => new Estado(estado.id, estado.descricao)
          );
        })
      );
  }
}
